<template>
    <v-container 
        fluid 
        px-0 
        pt-5>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col style="padding-bottom:0px;">
                        <v-file-input
                            v-model="file"
                            :key="'input_file_' + idExtServReqPk"
                            :label="labelFile"
                            :disabled="isLoaded && hasFile"
                            :loading="loading"
                            hide-details
                            solo
                            show-size
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col style="text-align:center">
                        <v-btn
                            v-if="isLoaded && hasFile"
                            :loading="loading"
                            small
                            style="margin-top: -6px;"
                            class="mr-1 mt-2"
                            @click="getDataDocumentoFile_()"
                        >
                            <v-icon>mdi-download</v-icon>
                            Descargar
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="objRequisito.idExtServReqPk != undefined">
                    <v-col style="text-align:center">
                        <v-alert
                            v-if="objRequisito.validado === true"
                            class="mb-0"
                            color="green"
                            style="color:white;"
                            dense
                        >
                            <v-row align="center">
                                <v-col
                                >Validado por
                                    <i>{{
                                        objRequisito.idUsuarioValidaNavigation !== undefined
                                            ? objRequisito.idUsuarioValidaNavigation.nombre
                                            : ""
                                    }}</i></v-col
                                    >
                                <v-col>
                                    {{
                                        objRequisito.fechaHValidacion !== undefined
                                            ? getFechaFormat(objRequisito.fechaHValidacion)
                                            : ""
                                    }}
                                </v-col>
                            </v-row>
                        </v-alert>

                        <v-alert
                            v-else-if="
                                objRequisito.validado === false &&
                                    objRequisito.observacionRechazado !== null
                            "
                            class="mb-0"
                            color="yellow lighten-1"
                            style="padding: 10px;"
                        >
                            <v-row align="center">
                                <v-col
                                >Observaciones por<br >
                                    <i>{{
                                        objRequisito.idUsuarioValidaNavigation !== undefined
                                            ? objRequisito.idUsuarioValidaNavigation.nombre
                                            : ""
                                    }}</i></v-col
                                    >
                                <v-col>
                                    {{
                                        objRequisito.fechaHValidacion !== undefined
                                            ? getFechaFormat(objRequisito.fechaHObservacionRechazado)
                                            : ""
                                    }}
                                </v-col>
                            </v-row>
                            <v-row align="center">
                                <v-col class="grow">
                                    <b>Observaciones: </b>
                                    {{ objRequisito.observacionRechazado }}
                                </v-col>
                            </v-row>
                        </v-alert>

                        <div v-else>
                            <v-btn
                                :loading="loadingVal"
                                dark
                                color="primary"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="openDialogObservaciones()"
                            >
                                <v-icon class="mr-1">mdi-comment-arrow-left-outline</v-icon>
                                Enviar observaciones
                            </v-btn>
                            <v-btn
                                :loading="loadingVal"
                                dark
                                color="success"
                                style="margin-top: -6px;"
                                class="mr-1 mt-2"
                                @click="validarRequisito()"
                            >
                                <v-icon class="mr-1">mdi-check-outline</v-icon>
                                Validar requisito
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

                <v-snackbar
                    v-model="snackbarGuardarDoc"
                    :key="'snackbar_val_file_' + idExtServReqPk"
                    :bottom="true"
                    :color="colorGuardarDoc"
                    :multi-line="true"
                    :timeout="timeoutGuardarDoc"
                >
                    {{ textGuardarDoc }}
                    <v-btn 
                        dark 
                        text 
                        @click="snackbarGuardarDoc = false">
                        Cerrar
                    </v-btn>
                </v-snackbar>

                <v-dialog 
                    v-model="dialogObs" 
                    max-width="500px">
                    <v-card>
                        <v-form 
                            ref="form" 
                            v-model="validObs" 
                            lazy-validation>
                            <v-card-title>
                                <span class="headline">Enviar observaciones</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col 
                                            cols="12" 
                                            sm="12" 
                                            md="12" 
                                            class="px-0">
                                            <span class="subtitle-2">Observaciones *</span>
                                            <v-textarea
                                                v-model="obs"
                                                :rules="[v => v !== '' || 'Campo requerido']"
                                                solo
                                                name="input-7-4"
                                                label="Por favor escriba las observaciones"
                                                required
                                                no-resize
                                            />
                                        </v-col>
                                    </v-row>
                                </v-container>
                                <small>* Campo obligatorio</small>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn
                                    :loading="loadingVal"
                                    color="blue darken-1"
                                    text
                                    @click="dialogObs = false"
                                >Cancelar</v-btn
                                >
                                <v-btn
                                    :loading="loadingVal"
                                    color="blue darken-1"
                                    text
                                    @click="confirmEnviarObservaciones()"
                                >Enviar observaciones</v-btn
                                >
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {
  getDataDocumentoUsuarioByIdExtServReq,
  getDataDocumentoFile,
  postDataExternoServicioRequisitoObservaciones,
  postDataExternoServicioRequisitoValidar
} from "@/api";

export default {
  name: "ValidacionDocumento",
  components: {},
  props: {
    idExtServReqPk: {
      type: Number,
      default: 0
    },
    actualizarRequisitos: {
      type: Function,
      required: true
    },
    refreshTable: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      file: null,
      loading: false,
      isLoaded: false,
      hasFile: false,
      labelFile: "",
      snackbarGuardarDoc: false,
      colorGuardarDoc: "",
      textGuardarDoc: "",
      timeoutGuardarDoc: 0,
      objDocumento: {},
      objRequisito: {},
      dialogObs: false,
      loadingVal: false,
      obs: "",
      validObs: false
    };
  },
  computed: {},
  mounted () {
    this.getDataDocumentoUsuarioByIdExtServReq_();
  },
  methods: {
    async getDataDocumentoUsuarioByIdExtServReq_ () {
      var self = this;
      self.loading = true;

      try {
        let response = await getDataDocumentoUsuarioByIdExtServReq(
          self.idExtServReqPk
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message !== "No hay archivo") {
              self.objDocumento = response.data.data.externoDocumento;
              self.objRequisito = response.data.data.externoServicioRequisito;

              self.labelFile =
                response.data.data.externoDocumento.nombreArchivo;
              self.nombreOriginal =
                response.data.data.externoDocumento.nombreArchivo;
              self.idArchivoPk =
                response.data.data.externoDocumento.idArchivoPk;
              self.uuid = response.data.data.externoDocumento.id;
              self.hasFile = true;
            } else {
              self.objDocumento = {};
              self.objRequisito = {};

              self.labelFile = "Sin documento";
              self.nombreOriginal = "";
              self.idArchivoPk = 0;
              self.uuid = "";
              self.hasFile = false;
            }

            self.file = null;

            self.loading = false;
            self.isLoaded = true;
          } else {
            self.objDocumento = {};
            self.objRequisito = {};

            self.colorGuardarDoc = "error";
            self.textGuardarDoc = response.data.message;
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            self.nombreOriginal = "";
            self.uuid = "";
            self.idArchivoPk = 0;

            self.hasFile = false;
            self.labelFile = "Sin documento";
            self.loading = false;
            self.isLoaded = true;
          }
        } else {
          self.objDocumento = {};
          self.objRequisito = {};

          self.colorGuardarDoc = "error";
          self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.nombreOriginal = "";
          self.uuid = "";
          self.idArchivoPk = 0;

          self.hasFile = false;
          self.labelFile = "Sin documento";
          self.loading = false;
          self.isLoaded = true;
        }
      } catch (e) {
        self.objDocumento = {};
        self.objRequisito = {};

        self.colorGuardarDoc = "error";
        self.textGuardarDoc =
          e.message === "Network Error"
            ? "Error de red. Inténtelo de nuevo más tarde."
            : e.message;
        self.timeoutGuardarDoc = 7000;
        self.snackbarGuardarDoc = true;

        self.nombreOriginal = "";
        self.uuid = "";
        self.idArchivoPk = 0;

        self.hasFile = false;
        self.labelFile = "Sin documento";
        self.loading = false;
        self.isLoaded = true;
      }
    },
    async getDataDocumentoFile_ () {
      var self = this;
      self.loading = true;

      try {
        let response = await getDataDocumentoFile(
          self.objDocumento.idArchivoPk,
          self.objDocumento.id
        );

        if (response.status === 200) {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", self.nombreOriginal);
          document.body.appendChild(fileLink);

          fileLink.click();

          self.loading = false;
        } else {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.loading = false;
        }
      } catch (e) {
        self.colorGuardarDoc = "error";
        self.textGuardarDoc =
          e.message === "Network Error"
            ? "Error de red. Inténtelo de nuevo más tarde."
            : e.message;
        self.timeoutGuardarDoc = 7000;
        self.snackbarGuardarDoc = true;

        self.loading = false;
      }
    },
    getFechaFormat (fecha) {
      return (
        fecha.substr(8, 2) +
        "/" +
        fecha.substr(5, 2) +
        "/" +
        fecha.substr(0, 4) +
        " " +
        fecha.substr(11, 2) +
        ":" +
        fecha.substr(14, 2) +
        " hrs"
      );
    },
    openDialogObservaciones () {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
        this.obs = "";
      }
      this.dialogObs = true;
    },
    async confirmEnviarObservaciones () {
      var self = this;
      if (self.$refs.form.validate()) {
        self.loadingVal = true;

        try {
          let response = await postDataExternoServicioRequisitoObservaciones(
            self.idExtServReqPk,
            self.obs
          );

          if (response.status === 200) {
            if (response.data.flag === true) {
              self.colorGuardarDoc = "success";
              self.textGuardarDoc = response.data.message;
              self.timeoutGuardarDoc = 7000;
              self.snackbarGuardarDoc = true;
              self.dialogObs = false;

              setTimeout(function () {
                self.loadingVal = false;

                self.actualizarRequisitos();
                self.refreshTable();
              }, 2000);
            } else {
              self.colorGuardarDoc = "error";
              self.textGuardarDoc = response.data.message;
              self.timeoutGuardarDoc = 7000;
              self.snackbarGuardarDoc = true;

              self.dialogObs = false;
              self.loadingVal = false;
            }
          } else {
            self.colorGuardarDoc = "error";
            self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            self.dialogObs = false;
            self.loadingVal = false;
          }
        } catch (e) {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc =
            e.message === "Network Error"
              ? "Error de red. Inténtelo de nuevo más tarde."
              : e.message;
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.dialogObs = false;
          self.loadingVal = false;
        }
      }
    },
    async validarRequisito () {
      var self = this;
      self.loadingVal = true;

      try {
        let response = await postDataExternoServicioRequisitoValidar(
          self.idExtServReqPk
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            self.colorGuardarDoc = "success";
            self.textGuardarDoc = response.data.message;
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            setTimeout(function () {
              self.loadingVal = false;

              self.actualizarRequisitos();
              self.refreshTable();
            }, 2000);
          } else {
            self.colorGuardarDoc = "error";
            self.textGuardarDoc = response.data.message;
            self.timeoutGuardarDoc = 7000;
            self.snackbarGuardarDoc = true;

            self.loadingVal = false;
          }
        } else {
          self.colorGuardarDoc = "error";
          self.textGuardarDoc = "Error. Inténtelo de nuevo más tarde.";
          self.timeoutGuardarDoc = 7000;
          self.snackbarGuardarDoc = true;

          self.loadingVal = false;
        }
      } catch (e) {
        self.colorGuardarDoc = "error";
        self.textGuardarDoc =
          e.message === "Network Error"
            ? "Error de red. Inténtelo de nuevo más tarde."
            : e.message;
        self.timeoutGuardarDoc = 7000;
        self.snackbarGuardarDoc = true;

        self.loadingVal = false;
      }
    }
  }
};
</script>
